import {ISmartAdOffer} from "../reducer/smart_ads_reducer";

export type ISmartAdsActionTypes = "ADD_SMART_AD_OFFER" | "REMOVE_SMART_AD_OFFERS" | "UPDATE_SMART_AD_OFFER" | "UPDATE_SSR_TDA_SHOW";

export type ISmartAdActions = IAddSmartAdOfferAction | IRemoveSmartAdOffers | IUpdateSmartAdOfferAction | ISsrTdaShow;

interface ISmartAdOfferAction {
    type: ISmartAdsActionTypes;
}

interface IAddSmartAdOfferAction extends ISmartAdOfferAction {
    type: "ADD_SMART_AD_OFFER";
    payload: ISmartAdOffer;
}

export const addSmartAdOfferAction: (payload: ISmartAdOffer) => IAddSmartAdOfferAction = (payload) => ({
    type: "ADD_SMART_AD_OFFER",
    payload
});

interface IUpdateSmartAdOfferAction extends ISmartAdOfferAction {
    type: "UPDATE_SMART_AD_OFFER";
    payload: Partial<ISmartAdOffer>;
}

export const updateSmartAdOfferAction: (payload: Partial<ISmartAdOffer>) => IUpdateSmartAdOfferAction = (payload) => ({
    type: "UPDATE_SMART_AD_OFFER",
    payload
});

interface IRemoveSmartAdOffers extends ISmartAdOfferAction {
    type: "REMOVE_SMART_AD_OFFERS";
}

export const removeSmartAdOffers: () => IRemoveSmartAdOffers = () => ({
    type: "REMOVE_SMART_AD_OFFERS"
});

interface ISsrTdaShow extends ISmartAdOfferAction {
    type: "UPDATE_SSR_TDA_SHOW";
    payload: boolean;
}

export const changeSsrTdaShow: (payload: boolean) => ISsrTdaShow = (payload) => ({
    type: "UPDATE_SSR_TDA_SHOW",
    payload
});
import {ISmartAdOffer} from "../reducer/smart_ads_reducer";

export type ISmartAdsActionTypes = "ADD_SMART_AD_OFFER" | "REMOVE_SMART_AD_OFFERS" | "UPDATE_SMART_AD_OFFER" | "UPDATE_SSR_TDA_SHOW";

export type ISmartAdActions = IAddSmartAdOfferAction | IRemoveSmartAdOffers | IUpdateSmartAdOfferAction | ISsrTdaShow;

interface ISmartAdOfferAction {
    type: ISmartAdsActionTypes;
}

interface IAddSmartAdOfferAction extends ISmartAdOfferAction {
    type: "ADD_SMART_AD_OFFER";
    payload: ISmartAdOffer;
}

export const addSmartAdOfferAction: (payload: ISmartAdOffer) => IAddSmartAdOfferAction = (payload) => ({
    type: "ADD_SMART_AD_OFFER",
    payload
});

interface IUpdateSmartAdOfferAction extends ISmartAdOfferAction {
    type: "UPDATE_SMART_AD_OFFER";
    payload: Partial<ISmartAdOffer>;
}

export const updateSmartAdOfferAction: (payload: Partial<ISmartAdOffer>) => IUpdateSmartAdOfferAction = (payload) => ({
    type: "UPDATE_SMART_AD_OFFER",
    payload
});

interface IRemoveSmartAdOffers extends ISmartAdOfferAction {
    type: "REMOVE_SMART_AD_OFFERS";
}

export const removeSmartAdOffers: () => IRemoveSmartAdOffers = () => ({
    type: "REMOVE_SMART_AD_OFFERS"
});

interface ISsrTdaShow extends ISmartAdOfferAction {
    type: "UPDATE_SSR_TDA_SHOW";
    payload: boolean;
}

export const changeSsrTdaShow: (payload: boolean) => ISsrTdaShow = (payload) => ({
    type: "UPDATE_SSR_TDA_SHOW",
    payload
});
